import React from 'react';
import * as Widgets from './widgets';

/**
 * Maps Backend WidgetTypes to React Component Exports.
 * Keys must match Java WidgetType enum.
 */
const COMPONENT_MAP = {
  // --- Platform / Fallback ---
  'STEP_BY_STEP': 'StepByStepWidget',
  'SORTING': 'SortingWidget',
  'VISUAL_FEEDBACK': 'VisualFeedbackWidget',
  'NONE': 'NoneWidget',

  // --- Algebra & Equations ---
  'CARTESIAN_GRAPH': 'CartesianGraph',
  'FUNCTION_GRAPH': 'FunctionGraph',
  'EQUATION_INTERSECTION': 'EquationIntersection',
  'EQUATION_BALANCE_SCALE': 'EquationBalanceScaleWidget',
  'INEQUALITY_REGION': 'InequalityRegion',
  'VISUAL_MULTIPLIER': 'VisualMultiplier',
  'FUNCTION_MACHINE': 'FunctionMachine',
  'FUNCTION_MATCH': 'FunctionMatcher',
  'SEQUENCE_VISUALIZER': 'SequenceVisualizer',
  'EXPONENTIAL_GROWTH_DECAY': 'ExponentialGrowthDecay',
  'QUADRATIC_EXPLORER': 'QuadraticExplorer',

  // --- Number & Measurement ---
  'NUMBER_LINE': 'NumberLine',
  'FRACTION_MODEL': 'FractionModel',
  'UNIT_CONVERTER': 'UnitConverter',
  'PLACE_VALUE_BLOCKS': 'PlaceValueBlocks',
  'PLACE_VALUE_SLIDER': 'PlaceValueSlider',
  'NUMBER_GRID': 'NumberGrid',
  'INTERACTIVE_CLOCK': 'InteractiveClockWidget',
  'RATIO_MODEL': 'RatioModelWidget',
  'AREA_VOLUME_EXPLORER': 'AreaVolumeExplorerWidget',
  'COMPOSITE_AREA_PLANNER': 'CompositeAreaPlanner',
  'PYTHAGORAS': 'PythagorasVisualiser',

  // --- Geometry & Space ---
  'POLYGON': 'PolygonExplorer',
  'ANGLE_GEOMETRY': 'AngleGeometry',
  'ANGLE_MEASUREMENT': 'AngleMeasurementWidget',
  'GEOMETRY_PROPERTIES': 'GeometryProperties',
  'TRANSFORMATION': 'TransformationGrid',
  'CIRCLE_THEOREMS': 'CircleTheorems',
  'UNIT_CIRCLE': 'UnitCircle',
  'SOLID_3D': 'Solid3D',
  'SOLID_NET': 'SolidNetWidget',
  'GEOBOARD': 'Geoboard',
  'GEOMETRIC_CONSTRUCTION': 'GeometricConstruction',
  'SHAPE_SHIFTER': 'ShapeShifter',
  'DISTANCE_FORMULA': 'DistanceFormula',

  // --- Vector Calculus & Physics ---
  'VECTOR_FIELD': 'VectorField',
  'VECTOR_ADDITION': 'VectorAddition',

  // --- Statistics & Data ---
  'CENTER_VARIABILITY': 'CenterVariability',
  'CURVE_FIT': 'CurveFitting',
  'SCATTER_PLOT': 'ScatterPlot',
  'BOX_PLOT': 'BoxPlot',
  'HISTOGRAM': 'Histogram',
  'DOT_PLOT': 'DotPlot',
  'STEM_AND_LEAF': 'StemAndLeaf',
  'SAMPLING_SIMULATOR': 'SamplingSimulator',
  'TWO_WAY_TABLE_EXPLORER': 'TwoWayTableExplorer',

  // --- Probability ---
  'NORMAL_DISTRIBUTION': 'NormalDistributionWidget',
  'PROBABILITY_TREE': 'ProbabilityTree',
  'VENN_DIAGRAM': 'VennDiagram',
  'CHANCE_SIMULATOR': 'ChanceSimulator',
  'PROBABILITY_RACE': 'ProbabilityRace',

  // --- Calculus (10A & Beyond) ---
  'CALCULUS_GRAPHER': 'CalculusGrapher',
  'RIEMANN_SUM': 'RiemannSum',

  // --- Financial Maths ---
  'FINANCIAL_CALCULATOR': 'FinancialCalculatorWidget',
};

export const MathsFactory = ({ type, config, variables }) => {
  const componentName = COMPONENT_MAP[type];
  const Component = componentName ? Widgets[componentName] : null;

  if (!Component) {
    console.warn(
        `MathsFactory: No component implementation found for type "${type}".`
    );
    return (
        <div className="ch-alert-error padding--m border-radius--m">
          <strong>Unsupported Widget:</strong> {type}
        </div>
    );
  }

  return <Component config={config} variables={variables} />;
};